import { render, staticRenderFns } from "./form-date.vue?vue&type=template&id=771404bc"
import script from "./form-date.vue?vue&type=script&lang=js"
export * from "./form-date.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports